module.exports = __webpack_public_path__ + "static/media/slide5.431cf090.png";